<template>
  <div class="zan-steps">
    <div class="zan-steps__desc"></div>
    <div class="zan-steps__items">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'zan-steps'
  };
</script>



// WEBPACK FOOTER //
// steps.vue?2da33548